export const PRESIGNED_URL = "presigned-url/";
export const DOWNLOAD_URL = "download-url/";
